import { CTASize, MarketingCTA } from "../../components/MarketingCTA";
import { MarketingFooter } from "../../components/MarketingFooter";
import { MarketingGetStarted } from "../../components/MarketingGetStarted";
import { MarketingMenu } from "../../components/MarketingMenu";
import { MarketingOGTags } from "../../components/MarketingOGTags";
import { MarketingTextSVGHeader, PartnerDesktopSVG } from "../../components/MarketingTextSVGHeader";
import { FadeUpContainer } from "../../components/ReusableStyledComponents/FadeUp";
import { UnstyledLink } from "../../components/ReusableStyledComponents/UnstyledLink";
import { VerticalSpacing } from "../../components/VerticalSpacing";
import { theme } from "../../theme/theme";
import { PPPrimaryCTAWrapper } from "./PartnetPageLayout.styles";
import { MarketingPartnerSteps } from "../../components/MarketingSteps/MarketingPartnerSteps";
import Link from "next/link";
import { APPLICATION_ROUTES } from "../../shared-logic/routes";

interface PartnersPageLayoutProps {}

export const PartnersPageLayout = ({}: PartnersPageLayoutProps) => {
    return (
        <>
            <MarketingOGTags
                title="Authory – Help content creators be successful – and earn cash"
                description="If you have many followers on social media, or a newsletter or podcast, then become an Authory affiliate and earn USD 30 for every paying customer you refer."
                canonicalUrl={`${process.env.NEXT_PUBLIC_FRONTEND_URL}${APPLICATION_ROUTES.PARTNERS}`}
            />
            <MarketingMenu />
            <FadeUpContainer>
                <VerticalSpacing top={20} breakpoints={[{ screen: theme.breakpoints.tablet, marginTop: 50 }]}>
                    <MarketingTextSVGHeader
                        subtitle="Authory Partner Program"
                        title={
                            <>
                                Help content creators be successful <strong>– and earn cash</strong>
                            </>
                        }
                        description={
                            <>
                                If you have many followers on social media, or a newsletter or podcast, then become an Authory affiliate and{" "}
                                <strong>earn USD 30 for every paying customer you refer.</strong>
                            </>
                        }
                        desktopSVG={<PartnerDesktopSVG />}
                        mobileSVG={<></>}
                        textMaxWidth={860}
                        containerMaxWidth={1320}
                        mobileMaxWidth={344}
                        floatingComponent={
                            <PPPrimaryCTAWrapper>
                                <Link href={APPLICATION_ROUTES.SIGNUP} passHref legacyBehavior>
                                    <UnstyledLink>
                                        <MarketingCTA text="Join the Partner Program" size={CTASize.L} />
                                    </UnstyledLink>
                                </Link>
                            </PPPrimaryCTAWrapper>
                        }
                    />
                </VerticalSpacing>
                <VerticalSpacing top={120} breakpoints={[{ screen: theme.breakpoints.tablet, marginTop: 100 }]}>
                    <MarketingPartnerSteps />
                </VerticalSpacing>
                <VerticalSpacing top={120}>
                    <MarketingGetStarted
                        description=""
                        title="Ready to start earning?"
                        ctaLabel="Join the Partner Program"
                        ctaHref={APPLICATION_ROUTES.SIGNUP}
                        ctaTarget="_blank"
                    />
                </VerticalSpacing>
                <VerticalSpacing top={120}>
                    <MarketingFooter />
                </VerticalSpacing>
            </FadeUpContainer>
        </>
    );
};
